import React from 'react'
import PropTypes from 'prop-types'
import Slice from './Slice'

const radius = 100
const translationFactor = 1.1
const viewBox = [-1, -1, 2, 2].map(v => Math.trunc(v * translationFactor * radius)).join(' ')

// https://hackernoon.com/a-simple-pie-chart-in-svg-dbdd653b6936
const PieChart = ({ slices, className }) => (
  <svg viewBox={viewBox} style={{ transform: 'rotate(-0.25turn)' }} className={className}>
    {slices.map(({ key, ...slice }) => (
      <Slice key={key} {...slice} />
    ))}
  </svg>
)

PieChart.propTypes = {
  slices: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  )
}

export default PieChart
